import { render, staticRenderFns } from "./modal_medicacao.vue?vue&type=template&id=4b858851&scoped=true"
import script from "./modal_medicacao.vue?vue&type=script&lang=js"
export * from "./modal_medicacao.vue?vue&type=script&lang=js"
import style0 from "./modal_medicacao.vue?vue&type=style&index=0&id=4b858851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b858851",
  null
  
)

export default component.exports